import React from 'react';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const AnalyticsIcon: React.FC<IconProps> = ({
  className,
  disabled,
  active,
}): JSX.Element => {
  const stroke = disabled ? '#b8b8b8' : strokeColor(active);

  return (
    <svg
      width="20"
      height="26"
      viewBox="-5 -2 27 22.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8.7" cy="8" r="13.6" fill={circleColor(active)} />

      <rect
        x="3.91382"
        y="5.69678"
        width="2.0553"
        height="6.46022"
        rx="1"
        fill={stroke}
      />
      <rect
        x="7.62866"
        y="3.06348"
        width="2.0553"
        height="9.09342"
        rx="1"
        fill={stroke}
      />
      <rect
        x="11.7717"
        y="6.12354"
        width="2.0553"
        height="6.03337"
        rx="1"
        fill={stroke}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.15625 0.254883C1.70853 0.254883 2.15625 0.702598 2.15625 1.25488V10.2549C2.15625 12.464 3.94711 14.2549 6.15625 14.2549H15.1562C15.7085 14.2549 16.1562 14.7026 16.1562 15.2549C16.1562 15.8072 15.7085 16.2549 15.1562 16.2549H6.15625C2.84254 16.2549 0.15625 13.5686 0.15625 10.2549V1.25488C0.15625 0.702598 0.603965 0.254883 1.15625 0.254883Z"
        fill={stroke}
      />
    </svg>
  );
};
